module.exports = "/img/_/_/_/assets/images/creeper/book/rare//5.jpg?036388d771f3d20b07609d2d8db53bfa";